import {ChangeDetectionStrategy, Component, computed, inject, input} from '@angular/core';
import {CareproviderUnitType} from '../../../../../../types/CareproviderUnitType';
import {ReviewsEnum} from '../../../../../../enums/PluralEnums';
import {PluralService} from '../../../../../../services/plural.service';

@Component({
  selector: 'app-search-careprovider-unit-item-img-v2',
  templateUrl: './search-careprovider-unit-item-img-v2.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block w-full aspect-[314/136]',
  },
})
export class SearchCareproviderUnitItemImgV2Component {
  public hasImage = input<boolean>(null);
  public careproviderRouterLink = input<string[]>(null);
  public imageUrl = input<string>(null);
  public itemIndex = input<number>(null);
  public isPriorityImage = input<boolean>(null);
  public mainSegment = input<string>(null);
  public logoUrl = input<string>(null);
  public isCustomer = input<boolean>(null);
  public name = input<string>(null);
  public rating = input<number>(null);
  public reviesCount = input<number>(null);
  public mainCaregiverUnitType = input<CareproviderUnitType>(null);
  public isHsa = computed<boolean>(() => this.isCustomer() !== true);
  public loadingPriority = computed<'lazy' | 'eager' | 'auto'>(() => {
    if (this.isPriorityImage() === null) {
      return null;
    }
    return this.isPriorityImage() ? 'eager' : 'lazy';
  });
  public fetchPriority = computed<'high' | 'auto'>(() => {
    if (this.isPriorityImage() === null) {
      return null;
    }
    return this.isPriorityImage() ? 'high' : 'auto';
  });
  private pluralService = inject(PluralService);
  public ratingTooltip = computed<string>(() => {
    if (this.rating()) {
      return `${(Math.round(this.rating() * 10) / 10).toFixed(
        1,
      )}/5 (${this.reviesCount()} ${this.pluralService.getPluralString(ReviewsEnum, this.reviesCount(), false)})`;
    }
    return null;
  });
}
